module.exports = __webpack_public_path__ + "static/energy_14-d566e9661e844ec4ae740e79bd867587.jpg";